import axios from "../../../axios"
import { getCurrentTenant, parseObjectParamsToString, encodeToBase64 } from '@/utils'

export default {
  fetch(searchParams) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          chatOptions ${parseObjectParamsToString(searchParams)} {
            id,
            type,
            number,
            is_close,
            priority,
            description,
            has_department_redirect,
            userDepartment {
              id,
              activated
            },
            group {
              id,
              name
            },
            reasonOption {
              id,
              reason_id
            },
            parentOption {
              id,
              number,
              priority,
              has_department_redirect,
              description,
              userDepartment {
                id,
                activated
              },
              group {
                id,
                name
              },
              reasonOption {
                id,
                reason_id
              },
              parentOption {
                id,
                number,
                priority,
                has_department_redirect,
                description,
                userDepartment {
                  id,
                  activated
                },
                group {
                  id,
                  name
                },
                reasonOption {
                  id,
                  reason_id
                },
                parentOption {
                  id,
                  number,
                  priority,
                  has_department_redirect,
                  description,
                  userDepartment {
                    id,
                    activated
                  },
                  group {
                    id,
                    name
                  },
                  reasonOption {
                    id,
                    reason_id
                  },
                  parentOption {
                    id,
                    number,
                    priority,
                    has_department_redirect,
                    description,
                    userDepartment {
                      id,
                      activated
                    },
                    group {
                      id,
                      name
                    },
                    reasonOption {
                      id,
                      reason_id
                    },
                    parentOption {
                      id,
                      number,
                      priority,
                      has_department_redirect,
                      description,
                      userDepartment {
                        id,
                        activated
                      },
                      group {
                        id,
                        name
                      },
                      reasonOption {
                        id,
                        reason_id
                      },
                      parentOption {
                        id,
                        number,
                        priority,
                        has_department_redirect,
                        description,
                        userDepartment {
                          id,
                          activated
                        },
                        group {
                          id,
                          name
                        },
                        reasonOption {
                          id,
                          reason_id
                        },
                        parentOption {
                          id,
                          number,
                          priority,
                          has_department_redirect,
                          description,
                          userDepartment {
                            id,
                            activated
                          },
                          group {
                            id,
                            name
                          },
                          reasonOption {
                            id,
                            reason_id
                          },
                          parentOption {
                            id,
                            number,
                            priority,
                            has_department_redirect,
                            description,
                            userDepartment {
                              id,
                              activated
                            },
                            group {
                              id,
                              name
                            },
                            reasonOption {
                              id,
                              reason_id
                            }
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
            childOptions {
              id,
              number,
              priority,
              description,
              parent_option_id,
              userDepartment {
                id,
                activated
              },
              group {
                id,
                name
              },
              reasonOption {
                id,
                reason_id
              },
              parentOption {
                id,
                userDepartment {
                  id,
                  activated
                },
                group {
                  id,
                  name
                },
                reasonOption {
                  id,
                  reason_id
                },
              },
              type,
              is_close,
              childOptions {
                id,
                number,
                priority,
                description,
                parent_option_id,
                userDepartment {
                  id,
                  activated
                },
                group {
                  id,
                  name
                },
                reasonOption {
                  id,
                  reason_id
                },
                type,
                is_close,
                childOptions {
                  id,
                  number,
                  priority,
                  description,
                  parent_option_id,
                  userDepartment {
                    id,
                    activated
                  },
                  group {
                    id,
                    name
                  },
                  reasonOption {
                    id,
                    reason_id
                  },
                  type,
                  is_close,
                  childOptions {
                    id,
                    number,
                    priority,
                    description,
                    parent_option_id,
                    userDepartment {
                      id,
                      activated
                    },
                    group {
                      id,
                      name
                    },
                    reasonOption {
                      id,
                      reason_id
                    },
                    type,
                    is_close,
                    childOptions {
                      id,
                      number,
                      priority,
                      description,
                      parent_option_id,
                      type,
                      userDepartment {
                        id,
                        activated
                      },
                      group {
                        id,
                        name
                      },
                      reasonOption {
                        id,
                        reason_id
                      },
                      is_close,
                      childOptions {
                        id,
                        number,
                        priority,
                        description,
                        parent_option_id,
                        type,
                        userDepartment {
                          id,
                          activated
                        },
                        group {
                          id,
                          name
                        },
                        reasonOption {
                          id,
                          reason_id
                        },
                        is_close,
                        childOptions {
                          id,
                          number,
                          priority,
                          description,
                          parent_option_id,
                          type,
                          userDepartment {
                            id,
                            activated
                          },
                          group {
                            id,
                            name
                          },
                          reasonOption {
                            id,
                            reason_id
                          },
                          is_close,
                          childOptions {
                            id,
                            number,
                            priority,
                            description,
                            parent_option_id,
                            type,
                            userDepartment {
                              id,
                              activated
                            },
                            group {
                              id,
                              name
                            },
                            reasonOption {
                              id,
                              reason_id
                            },
                            is_close,
                            childOptions {
                              id,
                              number,
                              priority,
                              description,
                              parent_option_id,
                              type,
                              userDepartment {
                                id,
                                activated
                              },
                              group {
                                id,
                                name
                              },
                              reasonOption {
                                id,
                                reason_id
                              },
                              is_close
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `
    })
  },
  infos(chatOptionId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          chatOptionInfos (
            id: ${chatOptionId}
          ) {
            id,
            number,
            priority,
            description,
            has_department_redirect,
            userDepartment {
              id
            },
            group {
              id,
              name
            },
            reasonOption {
              id,
              reason_id
            },
            parentOption {
              id,
              number,
              priority,
              description,
              has_department_redirect,
              userDepartment {
                id
              },
              group {
                id,
                name
              },
              reasonOption {
                id,
                reason_id
              },
            },
            childOptions {
              id,
              number,
              priority,
              description
            }
          }
        }
      `
    })
  },
  backInfos: (parentId) => {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('',
      {
        query: `
          query {
            backInfos (
              parent_id: ${parentId}
            )
          }
        `
      }
    );
  },
  add(chatOption) {
    chatOption.description = encodeToBase64(chatOption.description)
    
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createChatOption ${parseObjectParamsToString(chatOption)} {
            id,
            number,
            priority,
            description,
            userDepartment {
              id
            },
            has_department_redirect,
            parentOption {
              id,
              number,
              priority,
              description,
              has_department_redirect,
              userDepartment {
                id
              },
              group {
                id,
                name
              },
              reasonOption {
                id,
                reason_id
              },
            },
            childOptions {
              id,
              number,
              priority,
              description
            }
          }
        }
      `
    })
  },
  update(chatOption) {
    chatOption.description = encodeToBase64(chatOption.description)
    
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateChatOption ${parseObjectParamsToString(chatOption)} {
            id,
            number,
            priority,
            description,
            userDepartment {
              id
            },
            has_department_redirect,
            parentOption {
              id,
              number,
              priority,
              description,
              has_department_redirect,
              userDepartment {
                id
              },
              group {
                id,
                name
              },
              reasonOption {
                id,
                reason_id
              },
            },
            childOptions {
              id,
              number,
              priority,
              description
            }
          }
        }
      `
    })
  },
  delete(chatOption) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteChatOption ${parseObjectParamsToString(chatOption)}
        }
      `
    })
  }
}
